import { render, staticRenderFns } from "./BooksInWriteOffSet.vue?vue&type=template&id=32e4bd8e&scoped=true&"
import script from "./BooksInWriteOffSet.vue?vue&type=script&lang=js&"
export * from "./BooksInWriteOffSet.vue?vue&type=script&lang=js&"
import style0 from "./BooksInWriteOffSet.vue?vue&type=style&index=0&id=32e4bd8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e4bd8e",
  null
  
)

export default component.exports